import dynamic from 'next/dynamic';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Badge from '../../atoms/Badge';
import BtnContactUs from '../../atoms/BtnContactUs';
import BtnLoginSignup from '../../atoms/BtnLoginSignup';
import GeoPosition from '../../atoms/GeoPosition';
import Input from '../../atoms/Input';
import NavLogo from '../../atoms/Icons/NavLogo';
import GeoLocation from '../../atoms/Icons/GeoLocation';
import PersonRedIconHeader from '../../atoms/Icons/PersonRedIconHeader';
import PersonIconHeader from '../../atoms/Icons/PersonIconHeader';
import CloseCircle from '../../atoms/Icons/CloseCircle';
import SearchIcon from '../../atoms/Icons/SearchIcon';
import Ellipse from '../../atoms/Ellipse';
import Close from '../../atoms/Close';
import ArrowForward from '../../atoms/Icons/ArrowForward';
import { MdMenu, MdOutlineShoppingCart, MdSearch } from 'react-icons/md';
import { useSelector } from 'react-redux';
import Link from 'next/link';
import Image from 'next/image';
import { contentService, promoService } from 'ui/services';
import useDebounce from '../../../hooks/useDebounce';
import useProduct from '../../../hooks/useProduct';
import searchResults from '../../../constants/searchResults';
import capitalizeText from '../../../helpers/utils/capitalizeText';
import navbarMenuList from '../../../helpers/utils/navbarMenuList';
import eventLocation from 'ui/lib/gtm/eventLocation';
import eventNavBar from 'ui/lib/gtm/eventNavBar';
import { useDispatch } from 'react-redux';
import { setShowLocationModal } from '../../../store/locationModal/actions';
import { IRootState } from '../../../store';
import { useRouter } from '../../../hooks/useCustomRouter';
import Arrow from '../../atoms/Icons/Arrow';
import eventClicButtonLoginSignUp from '../../../lib/gtm/eventClickButtonLoginSignup';
import BtnCart, { CountCart } from '../../atoms/BtnCart';
import useImpressionHomepage from '../../../hooks/emarsys/homepage/useImpressionHomepage';
import eventClickHomepage from '../../../helpers/emarsys/homepage/eventClickHomepage';
import removeDoubleSlashes from '../../../helpers/utils/removeDoubleSlashes';

const SearchBoxAutoComplete = dynamic(
  () => import('ui/components/molecules/SearchBoxAutoComplete'),
  {
    ssr: false,
  }
);

const ModalChoosePlace = dynamic(() => import('ui/components/molecules/ModalChoosePlace'), {
  ssr: false,
});

const LoginForm = dynamic(() => import('ui/components/molecules/LoginForm'), {
  ssr: false,
});

export interface NavbarProps {
  userData?: {
    name?: string;
  };
  isAuth?: boolean;
  isLoggedIn?: boolean;
  showBottomMenu?: boolean;
  onSubmitCity?: (submit: {
    province?: string;
    isocode?: string;
    city?: string;
    allCity?: string[];
    cityIso?: string;
  }) => void;
  reloadWhenLocationChange?: boolean;
  isHideNavbar?: boolean;
  showButtonBack?: boolean;
  backTitle?: string;
  customBackURL?: string;
  isUsingDefaultAnchor?: boolean;
  isHomepage?: boolean;
}

const Navbar = ({
  userData,
  isAuth,
  isLoggedIn,
  showBottomMenu = true,
  onSubmitCity,
  reloadWhenLocationChange = false,
  isHideNavbar,
  showButtonBack = false,
  backTitle,
  customBackURL,
  isUsingDefaultAnchor = false,
  isHomepage,
}: NavbarProps) => {
  const { city } = useSelector((state: IRootState) => state.geolocation);
  const { unreadMessage, showBadge } = useSelector((state: IRootState) => state.tasia);

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [inputValues, setInputValues] = useState('');
  const [location, setLocation] = useState(city);
  const [openModal, setOpenModal] = useState(false);
  const [showSearchAction, setShowSearchAction] = useState(false);
  const [, setInquiryData] = useState(null);
  const [showAutoCompleteBox, setShowAutoCompleteBox] = useState(false);
  const [banner, setBanner] = useState('');

  // Show Modal
  const dispatch = useDispatch();
  const { showModal: showModalGeo } = useSelector((state: IRootState) => state.locationModal);
  const setShowModalGeo = (show) => {
    dispatch(
      setShowLocationModal({
        showModal: show,
        shouldCheckCityBranch: true,
        feature: '',
      })
    );
  };

  const [hasWindow, setHasWindow] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [dataSearch, setDataSearch] = useState({});

  const { getDataAutoComplete } = useProduct();

  const router = useRouter();
  const [stateURL, setStateURL] = useState<string>();

  const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;
  const NEXT_PUBLIC_BASEPATH_URL = process.env.NEXT_PUBLIC_BASEPATH_URL;

  // to avoid hydration error
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHasWindow(true);
      const urlObject = new URL(window?.location?.href);
      const newPath = urlObject.pathname.substring(1);
      setStateURL(newPath);
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('banner-url-location')) {
      setBanner(sessionStorage.getItem('banner-url-location'));
    } else {
      contentService.getBannerLocation().then((res) => {
        if (res?.data?.bannerUrl) {
          sessionStorage.setItem('banner-url-location', res?.data?.bannerUrl);
          setBanner(res?.data?.bannerUrl);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (city) {
      setLocation(city);
    }

    getPromo();
  }, [city]);

  useEffect(() => {
    const handleResize = () => {
      if (
        isMobileMenuOpen === true ||
        showAutoCompleteBox === true ||
        showSearchAction === true ||
        showModalGeo === true
      ) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobileMenuOpen, showAutoCompleteBox, showSearchAction, showModalGeo]);

  const getPromo = async () => {
    // const data = await promoService.getPromoNational({
    //   page: 0,
    //   size: 1,
    // });
    await promoService.getPromoNational({
      page: 0,
      size: 1,
    });
  };

  const handleSubmit = (payload) => {
    setInquiryData(payload);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    if (
      isMobileMenuOpen === true ||
      showAutoCompleteBox === true ||
      showSearchAction === true ||
      showModalGeo === true
    ) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMobileMenuOpen, showAutoCompleteBox, showSearchAction, showModalGeo]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValues(newValue);
    if (newValue.length >= 3) {
      setShowAutoCompleteBox(true);
    } else {
      setShowAutoCompleteBox(false);
    }
  };

  // Show Modal
  const onShowModal = () => {
    eventLocation();
    setShowModalGeo(true);
  };

  // Open search bar mobile
  const openSearchMobile = () => {
    setShowSearchAction(true);
  };

  const handleSubmtittedValue = (event) => {
    if (event.key === 'Enter') {
      window.location.href = `${process.env.NEXT_PUBLIC_URL}/search/global?text=${inputValues}`;
    }
  };
  const handleChangeLocation = (e) => {
    setLocation(e);
  };

  const handleCloseShowSearch = () => {
    setShowSearchAction(false);
    setShowAutoCompleteBox(false);
    setInputValues('');
  };

  const handleMenuHover = () => {
    setIsMenuOpen(true);
  };

  const handleMenuLeave = () => {
    setIsMenuOpen(false);
  };

  const handleClickNav = (item, subItem?) => {
    eventNavBar(item, subItem);
  };
  const debouncedValue = useDebounce(inputValues, 1500);

  const searchGlobal = useCallback(async () => {
    if (!debouncedValue) return;

    try {
      const response = await getDataAutoComplete(debouncedValue);

      if (!response || response.error) {
        throw new Error('Failed to fetch data');
      }

      const categorySearchResult = searchResults.filter((data) =>
        data?.name.toLowerCase().includes(debouncedValue.toLowerCase())
      );

      const combinedResult = [...categorySearchResult, ...response];
      setDataSearch({ data: combinedResult, error: null }); // Includes an error property with a null value
    } catch (error) {
      // Handle the error, e.g., log it or show a user-friendly message
      console.error('Error fetching data:', error.message);

      // Set error prop in the state
      setDataSearch({ data: [], error: 'Gagal menampilkan data' });
    }
  }, [debouncedValue, searchResults, setDataSearch]);

  const handleOnClickRemoveSearch = () => {
    setInputValues('');
    setShowAutoCompleteBox(false);
  };

  const handleOnClickCloseMobileMenu = () => setMobileMenuOpen(false);

  const realUrl = `${PUBLIC_URL}/` + stateURL;

  useEffect(() => {
    searchGlobal();
  }, [debouncedValue, searchGlobal]);

  const normalizePathname = [router.pathname, router.basePath]
    .map((item) => item.replace(/-/g, ''))
    .join('');

  const getValidMenu = (value: string) => {
    if (!value) return false;

    const isCurrentPageActive =
      normalizePathname.includes(value) && !normalizePathname.includes('myaccount');

    if (router.basePath !== '') {
      return isCurrentPageActive && router.basePath.replace(/-/g, '').includes(value);
    }
    return isCurrentPageActive;
  };

  const isValueHome = realUrl === `${PUBLIC_URL}/`;
  const isValueMobil = realUrl.includes('mobil-baru-toyota');
  const isValueService = realUrl === `${PUBLIC_URL}/services-toyota/booking-service`;
  const isRealUrlInMenu = navbarMenuList.menu.some((item) => getValidMenu(item?.value));

  //emarsys impression
  const impressionRef = useRef(null);
  if (isHomepage) {
    useImpressionHomepage(impressionRef, 'homepage auto2000', 'header category');
  }

  const removeDsrValue = () => {
    if (router.asPath !== '/hubungi-kami' && sessionStorage.getItem('dsrValue')) {
      sessionStorage?.removeItem('dsrValue');
    }
  };

  return (
    <React.Fragment>
      <nav
        ref={impressionRef}
        className="sticky top-0 h-10 lg:h-12 xl:h-11 w-full z-[55] bg-white lg:border-b border-[#dadce0] hidden lg:block"
      >
        {/* Top Navbar */}
        <div className="container px-0 flex items-center justify-end">
          <div className="flex lg:pt-1 xl:pt-0 px-2 xl:px-0">
            <BtnContactUs
              onClick={() => {
                eventClickHomepage('homepage auto2000', 'header category', 'hubungi kami');
                removeDsrValue();
              }}
            />
            <GeoPosition
              value={location}
              navBar={true}
              options={['Jakarta Pusat', 'Bandung', 'Yogyakarta', 'Nanggroe Aceh Darussalam']}
              onChange={handleChangeLocation}
              classNameContainer="bg-white"
              onShowModal={onShowModal}
              withChevron={false}
            />
            <BtnCart
              onClick={() => {
                eventClickHomepage('homepage auto2000', 'header category', 'cart');
              }}
            />
            {isAuth ? (
              isLoggedIn && userData ? (
                <a
                  className="flex items-center gap-1 px-1 text-reliableBlack"
                  href={`${PUBLIC_URL}/myaccount/overview`}
                  onClick={() => {
                    eventClickHomepage('homepage auto2000', 'header category', 'profile');
                  }}
                >
                  <PersonRedIconHeader />
                  <span className="text-xs font-semibold">{userData?.name}</span>
                </a>
              ) : (
                <BtnLoginSignup
                  onClick={() => {
                    eventClicButtonLoginSignUp('click on masuk/daftar');
                    eventClickHomepage('homepage auto2000', 'header category', 'masuk/daftar');
                  }}
                />
              )
            ) : (
              <Link
                href="#"
                className="px-1 flex items-center"
                onClick={() => {
                  eventClicButtonLoginSignUp('click on masuk/daftar');
                  eventClickHomepage('homepage auto2000', 'header category', 'masuk/daftar');
                }}
              >
                <PersonIconHeader size={20} fill={`#4F4C4D`} />
              </Link>
            )}
          </div>
        </div>
      </nav>

      {openModal && (
        <LoginForm
          onSubmit={handleSubmit}
          visible={openModal}
          onClose={() => setOpenModal(false)}
        />
      )}

      {/* Show Modal Geo Location */}
      <ModalChoosePlace
        visible={showModalGeo}
        onClose={() => setShowModalGeo(false)}
        onSubmitCity={onSubmitCity}
        reloadWhenLocationChange={reloadWhenLocationChange}
        bannerImage={banner}
      />

      {!isHideNavbar && (
        <nav
          className={`sticky top-0 lg:top-[44.25px] xl:top-[43.5px] w-full z-[60] bg-white lg:border-b lg:border-reliableBlack50 h-[60px] flex items-center lg:h-16 xl:h-[81px]`}
        >
          {/* Top Dekstop Navbar */}
          <div className="container xl:px-0">
            {/* Logo */}
            <div className="flex items-center justify-between">
              <a
                data-testid="icon_digi"
                className="flex justify-center xl:justify-start items-center xl:items-start h-11 lg:mr-3 xl:mr-5"
                id="nav-logo"
                href={PUBLIC_URL ?? '/'}
              >
                <NavLogo height="lg:h-auto xl:h-[40px] lg:w-[125px] xl:w-[125px]" />
              </a>

              <div className="flex lg:gap-2 xl:gap-[21px]">
                {navbarMenuList.menu.map((item) => (
                  <div
                    key={`navbar-menu-${item.id}`}
                    data-testid={item.dataTestId}
                    className="hidden lg:flex uppercase whitespace-nowrap lg:text-[13px] xl:text-[14px] lg:gap-2 xl:gap-4"
                  >
                    <Link
                      prefetch={false}
                      onClick={() => {
                        if (!isMenuOpen) {
                          handleClickNav(item.name);
                          eventClickHomepage(
                            'homepage auto2000',
                            'header category',
                            item?.name?.toLowerCase()
                          );
                        }
                      }}
                      id={`nav-${item.name.toLowerCase().replace(/\s/g, '-')}`}
                      className={`text-reliableBlack py-[30px] hover:text-supportiveRed ${
                        getValidMenu(item?.value) ? 'font-bold' : ''
                      } group`}
                      href={item.path}
                    >
                      {item.name === 'Purna Jual' ? (
                        hasWindow ? (
                          <div className="relative inline-block">
                            <span className="cursor-pointer">{item.name}</span>
                            <div
                              onMouseEnter={handleMenuHover}
                              onMouseLeave={handleMenuLeave}
                              className={`${
                                isMenuOpen ? 'flex' : 'hidden'
                              } h-[188px] text-[8px] lg:text-sm font-semibold uppercase group-hover:flex justify-center items-center fixed inset-x-0 lg:top-[104px] xl:top-[124px] z-50 bg-white shadow-md lg:py-[12px] xl:py-[28px]`}
                            >
                              <div className="container xl:px-0 flex justify-between space-x-4">
                                {item?.listMenu?.map((item, index) =>
                                  isUsingDefaultAnchor ? (
                                    <a
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleClickNav(navbarMenuList.menu[1].name, item.title);
                                        eventClickHomepage(
                                          'homepage auto2000',
                                          'header category',
                                          item?.title?.toLowerCase()
                                        );
                                      }}
                                      key={`purna-jual-item-${index}`}
                                      id={`nav-${item.id}`}
                                      href={item.path}
                                      className="text-reliableBlack hover:text-supportiveRed rounded-xl w-full mx-auto py-2 flex flex-col justify-center items-center"
                                    >
                                      <Image
                                        src={item.image}
                                        alt={`${item.title} icon`}
                                        className="w-6 lg:w-[60px] h-auto mb-[16px]"
                                        width={500}
                                        height={500}
                                      />
                                      {item.title}
                                    </a>
                                  ) : (
                                    <Link
                                      prefetch={false}
                                      onClick={() => {
                                        handleClickNav(navbarMenuList.menu[1].name, item.title);
                                        eventClickHomepage(
                                          'homepage auto2000',
                                          'header category',
                                          item?.title?.toLowerCase()
                                        );
                                      }}
                                      key={`purna-jual-item-${index}`}
                                      id={`nav-${item.id}`}
                                      href={item.path}
                                      className="text-reliableBlack hover:text-supportiveRed rounded-xl w-full mx-auto py-2 flex flex-col justify-center items-center"
                                    >
                                      <Image
                                        src={item.image}
                                        alt={`${item.title} icon`}
                                        className="w-6 lg:w-[60px] h-auto mb-[16px]"
                                        width={500}
                                        height={500}
                                      />
                                      {item.title}
                                    </Link>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          item.name
                        )
                      ) : (
                        item.name
                      )}
                    </Link>
                  </div>
                ))}
              </div>
              {/* Mobile Navbar */}
              <div className="flex right-4 lg:hidden gap-x-5">
                <Link
                  className="flex justify-center items-center gap-1 text-reliableBlack hover:text-reliableBlack70"
                  onClick={() => {
                    setShowModalGeo(true);
                    eventLocation();
                    eventClickHomepage('homepage auto2000', 'header category', 'pilih lokasi');
                  }}
                  href={removeDoubleSlashes(`${NEXT_PUBLIC_BASEPATH_URL}/${router.asPath}#`)}
                  aria-label="geo location link"
                ></Link>

                <div className="flex lg:gap-2 xl:gap-[21px]">
                  {navbarMenuList.menu.map((item) => (
                    <div
                      key={`navbar-menu-${item.id}`}
                      className="hidden lg:flex uppercase whitespace-nowrap lg:text-[10px] xl:text-[14px] lg:gap-2 xl:gap-4"
                    >
                      <Link
                        onClick={() => {
                          if (!isMenuOpen) {
                            handleClickNav(item.name);
                          }
                          eventClickHomepage(
                            'homepage auto2000',
                            'header category',
                            item?.name?.toLowerCase()
                          );
                        }}
                        id={`nav-${item.name.toLowerCase().replace(/\s/g, '-')}`}
                        className={`text-reliableBlack py-[30px] hover:text-supportiveRed ${
                          getValidMenu(item?.value) ? 'font-bold' : ''
                        } group`}
                        href={item.path}
                      >
                        {item.name === 'Purna Jual' ? (
                          hasWindow ? (
                            <div className="relative inline-block">
                              <span className="cursor-pointer">{item.name}</span>
                              <div
                                onMouseEnter={handleMenuHover}
                                onMouseLeave={handleMenuLeave}
                                className={`${
                                  isMenuOpen ? 'flex' : 'hidden'
                                } h-[188px] text-[8px] lg:text-sm font-semibold uppercase group-hover:flex justify-center items-center fixed inset-x-0 lg:top-[104px] xl:top-[124px] z-50 bg-white shadow-md lg:py-[12px] xl:py-[28px]`}
                              >
                                <div className="container xl:px-0 flex justify-between space-x-4">
                                  {item?.listMenu?.map((item, index) =>
                                    isUsingDefaultAnchor ? (
                                      <a
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleClickNav(navbarMenuList.menu[1].name, item.title);
                                        }}
                                        key={`purna-jual-item-${index}`}
                                        id={`nav-${item.id}`}
                                        href={item.path}
                                        className="text-reliableBlack hover:text-supportiveRed rounded-xl w-full mx-auto py-2 flex flex-col justify-center items-center"
                                      >
                                        <Image
                                          src={item.image}
                                          alt={`${item.title} icon`}
                                          className="w-6 lg:w-[60px] h-auto mb-[16px]"
                                          width={500}
                                          height={500}
                                        />
                                        {item.title}
                                      </a>
                                    ) : (
                                      <Link
                                        onClick={() => {
                                          handleClickNav(navbarMenuList.menu[1].name, item.title);
                                          eventClickHomepage(
                                            'homepage auto2000',
                                            'header category',
                                            item?.title?.toLowerCase()
                                          );
                                        }}
                                        key={`purna-jual-item-${index}`}
                                        id={`nav-${item.id}`}
                                        href={item.path}
                                        className="text-reliableBlack hover:text-supportiveRed rounded-xl w-full mx-auto py-2 flex flex-col justify-center items-center"
                                      >
                                        <Image
                                          src={item.image}
                                          alt={`${item.title} icon`}
                                          className="w-6 lg:w-[60px] h-auto mb-[16px]"
                                          width={500}
                                          height={500}
                                        />
                                        {item.title}
                                      </Link>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : (
                            item.name
                          )
                        ) : (
                          item.name
                        )}
                      </Link>
                    </div>
                  ))}
                </div>
                {/* Mobile Navbar */}
                <div className="flex right-4 lg:hidden gap-x-5">
                  <button
                    className="flex justify-center items-center gap-1 text-reliableBlack hover:text-reliableBlack70"
                    onClick={openSearchMobile}
                    aria-label="search button"
                  >
                    <SearchIcon size={20} fill="#333333" />
                  </button>
                  <Link
                    className="flex justify-center items-center gap-1 text-reliableBlack hover:text-reliableBlack70"
                    onClick={() => {
                      setShowModalGeo(true);
                      eventLocation();
                      eventClickHomepage('homepage auto2000', 'header category', 'pilih lokasi');
                    }}
                    aria-label="geo location link"
                    href={removeDoubleSlashes(`${NEXT_PUBLIC_BASEPATH_URL}/${router.asPath}#`)}
                  >
                    <GeoLocation width={20} height={20} fill="#333333" />
                  </Link>

                  <Link
                    className="flex justify-center items-center gap-1 text-reliableBlack hover:text-reliableBlack70 relative"
                    href={`${process.env.NEXT_PUBLIC_URL}/cart`}
                    aria-label="cart"
                    onClick={() =>
                      eventClickHomepage('homepage auto2000', 'header category', 'cart')
                    }
                  >
                    <MdOutlineShoppingCart width={20} height={20} fill="#333333" />
                    <CountCart position="top-[-4px] left-[12px]" />
                  </Link>

                  <a
                    className="flex justify-center items-center gap-1 text-reliableBlack hover:text-reliableBlack70"
                    href={`${PUBLIC_URL}/${userData && isLoggedIn ? 'myaccount/overview' : 'login'}`}
                    {...(userData
                      ? {}
                      : {
                          onClick: () => {
                            eventClicButtonLoginSignUp('click on masuk/daftar');
                            eventClickHomepage(
                              'homepage auto2000',
                              'header category',
                              userData && isLoggedIn ? 'profile' : 'masuk/daftar'
                            );
                          },
                        })}
                    aria-label="login link"
                  >
                    {userData && isLoggedIn ? (
                      <PersonRedIconHeader />
                    ) : (
                      <PersonIconHeader size={20} fill={`#4F4C4D`} />
                    )}
                  </a>
                </div>
              </div>

              {/* Desktop search bar */}
              <div className="hidden lg:block ml-4 mb-2">
                <Input
                  id="dd-search-navbar"
                  type="text"
                  placeholder={'Pencarian'}
                  icon={
                    inputValues ? (
                      <CloseCircle size={16} />
                    ) : (
                      <SearchIcon size={20} fill="#231F20" />
                    )
                  }
                  iconPosition="right"
                  iconClassName="lg:pr-2 lg:pr-5 mt-1"
                  labelClassName="text-reliableBlack70 font-semibold"
                  onChange={handleChange}
                  onKeyPress={handleSubmtittedValue}
                  inputClassName={
                    '!h-10 placeholder:!text-reliableBlack30 !pl-3 !py-[10px] h-8 placeholder:text-[12px] placeholder:italic !text-xs'
                  }
                  inputBackground={'bg-white'}
                  inputWrapperClassName={'h-10'}
                  value={inputValues}
                  containerClassName={'lg:ml-4 lg:ml-0 h-8 lg:max-w-[155px] xl:max-w-[216px]'}
                  handleOnClickIcon={inputValues ? handleOnClickRemoveSearch : null}
                />

                {showAutoCompleteBox && (
                  <React.Fragment>
                    <div
                      className="absolute top-[40px] left-0 h-screen w-screen bg-black bg-opacity-25 z-30 lg:top-[62px] xl:top-[80px]"
                      onClick={handleOnClickRemoveSearch}
                    ></div>
                    <div className="relative">
                      <SearchBoxAutoComplete dataSearch={dataSearch} value={debouncedValue} />
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </nav>
      )}

      {showButtonBack && (
        <div className="sticky top-[60px] bg-white z-[60] lg:hidden w-full border-b border-reliableBlack10">
          <button
            type="button"
            onClick={() => (customBackURL ? window.location.replace(customBackURL) : router.back())}
            className="container py-[10px] flex items-center gap-x-2"
            aria-label="back button"
          >
            <Arrow direction="left" color="#393536" />
            {Boolean(backTitle) && (
              <p className="text-reliableBlack80 font-bold text-sm">{backTitle}</p>
            )}
          </button>
        </div>
      )}
      {showBottomMenu && (
        <div
          id="mobileNavList"
          className="z-50 fixed bottom-0 left-0  lg:hidden w-full flex flex-col"
        >
          <div className="bg-[#333333]">
            <div className="flex items-center justify-between h-[70px] whitespace-nowrap">
              {/* Mobile Menu Toggle */}
              {navbarMenuList
                .mobileMenu({ isValueHome, isValueMobil, isValueService, isRealUrlInMenu })
                .map((item, index) => {
                  return (
                    <React.Fragment key={`bottom-menu-${index}`}>
                      {isUsingDefaultAnchor ? (
                        <a
                          id={item.id}
                          data-testid={item.dataTestId}
                          className="flex flex-col justify-center items-center text-[#bebebe] text-xs text-center w-1/5 py-2 hover:bg-gray-600"
                          key={`menu-item-${index}`}
                          href={item?.path}
                          onClick={() => {
                            if (item?.onClick) item?.onClick();
                            if (
                              item?.title !== 'home' &&
                              item?.title?.toLowerCase() !== 'tanya tasia'
                            ) {
                              eventClickHomepage(
                                'homepage auto2000',
                                'header category',
                                item?.title?.toLowerCase()
                              );
                            }
                          }}
                          {...(item.title === 'Tanya Tasia' && { 'data-open-chat': true })}
                        >
                          <div
                            className={`h-1 w-1 ${item?.redCircle ? 'bg-red-600' : ''} rounded-full`}
                          ></div>
                          {item.title === 'Tanya Tasia' ? (
                            <div className="relative -mt-0.5 mb-[6px]">
                              {item.icon}
                              {unreadMessage && showBadge ? (
                                <Badge statusClass="absolute top-[-7px] right-[-6px] bg-red-600 !w-4 !h-4 text-white border-none flex justify-center items-center p-0 !text-[8px]">
                                  {unreadMessage}
                                </Badge>
                              ) : null}
                            </div>
                          ) : (
                            <div className="mb-[3px]">{item.icon}</div>
                          )}
                          {item.title}
                        </a>
                      ) : (
                        <Link
                          id={item.id}
                          data-testid={item.dataTestId}
                          className="flex flex-col justify-center items-center text-[#bebebe] text-xs text-center w-1/5 py-2 hover:bg-gray-600"
                          key={`menu-item-${index}`}
                          href={item?.path}
                          onClick={() => {
                            if (item?.onClick) item?.onClick();
                            if (
                              item?.title !== 'home' &&
                              item?.title?.toLowerCase() !== 'tanya tasia'
                            ) {
                              eventClickHomepage(
                                'homepage auto2000',
                                'header category',
                                item?.title?.toLowerCase()
                              );
                            }
                          }}
                          {...(item.title === 'Tanya Tasia' && { 'data-open-chat': true })}
                        >
                          <div
                            className={`h-1 w-1 ${item?.redCircle ? 'bg-red-600' : ''} rounded-full`}
                          ></div>
                          {item.title === 'Tanya Tasia' ? (
                            <div className="relative -mt-0.5 mb-[6px]">
                              {item.icon}
                              {unreadMessage && showBadge ? (
                                <Badge statusClass="absolute top-[-7px] right-[-6px] bg-red-600 !w-4 !h-4 text-white border-none flex justify-center items-center p-0 !text-[8px]">
                                  {unreadMessage}
                                </Badge>
                              ) : null}
                            </div>
                          ) : (
                            <div className="mb-[3px]">{item.icon}</div>
                          )}
                          {item.title}
                        </Link>
                      )}
                      <div className="h-[13px] w-[0.3px] bg-[#bebebe] mb-3" />
                    </React.Fragment>
                  );
                })}
              {/* Hamburger Menu */}
              <button
                data-testid="burger_menu"
                className="flex flex-col justify-center items-center text-white text-xs text-center w-1/5"
                onClick={toggleMobileMenu}
              >
                <div
                  className={`h-1 w-1 ${
                    isValueMobil ? '' : `${isRealUrlInMenu ? 'bg-red-600' : ''}`
                  }  rounded-full`}
                ></div>
                <MdMenu
                  size={24}
                  fill={`${isValueMobil ? '#BEBEBE' : `${isRealUrlInMenu ? '#FFFFFF' : '#BEBEBE'}`}`}
                />
                <span className="mt-[2px]">Lainnya</span>
              </button>
            </div>
          </div>

          {/* Mobile Menu Items */}
          <div
            className={`absolute z-[60] bottom-0 left-0 bg-[#2c2b2b] w-full flex flex-col rounded-t ${
              isMobileMenuOpen ? 'block' : 'hidden'
            }`}
          >
            <div className="flex justify-between py-[22px] pr-[30px] pl-[15px] border-b border-reliableBlack50">
              <div className="flex justify-center items-center space-x-[10px]">
                <React.Fragment>
                  <Ellipse {...(userData && { fill: '#4cc0ad' })} />
                  <span className="text-reliableBlack3 uppercase font-medium text-[16px] leading-[26px]">
                    {userData ? `Hai, ${userData?.name}` : `MENU`}
                  </span>
                </React.Fragment>
              </div>
              <div className="cursor-pointer" onClick={handleOnClickCloseMobileMenu}>
                <Close />
              </div>
            </div>
            <div className="px-[16px]">
              <a
                data-testid="login_akun"
                className="flex justify-between items-center pt-[24px] pr-[24px] pl-[16px] pb-[17px] border-b-[0.5px] border-reliableBlack50"
                href={`${PUBLIC_URL}/${userData ? 'myaccount/overview' : 'login'}`}
                onClick={() => {
                  eventClickHomepage(
                    'homepage auto2000',
                    'header category',
                    userData && isLoggedIn ? 'profile' : 'masuk/daftar'
                  );
                }}
              >
                <p className={`hover:bg-gray-600 uppercase text-[#bebebe] font-medium`}>
                  {userData ? 'Akun Saya' : 'Masuk / Registrasi'}
                </p>
                <div>
                  <ArrowForward size={24} />
                </div>
              </a>
              {navbarMenuList.menu
                .filter((item) => item.hideOnMobile === false)
                .map((item, index) => (
                  <div key={`mobile-menu-item-${index}`} data-testid={item.dataTestId}>
                    <Link
                      className="flex justify-between items-center pt-[16px] pr-[24px] pl-[16px] pb-[15px] leading-[18px] border-b-[0.5px] border-reliableBlack50"
                      href={item.path}
                      onClick={() => {
                        item?.onClick();
                        eventClickHomepage(
                          'homepage auto2000',
                          'header category',
                          item?.name?.toLowerCase()
                        );
                      }}
                    >
                      <p
                        className={`hover:bg-gray-600 uppercase ${
                          getValidMenu(item?.value)
                            ? 'text-white font-bold '
                            : 'text-[#bebebe] font-medium'
                        }`}
                      >
                        {item.name}
                      </p>
                      <div>
                        <ArrowForward size={24} />
                      </div>
                    </Link>
                  </div>
                ))}
            </div>
            <div className="flex items-center whitespace-nowrap pl-[25px] pr-[15px] pt-[21px] pb-[19px] max-h-[59px]">
              <div className="pt-[6px]">
                <span className="text-xs text-[#A3A3A3] mr-8">ID</span>
              </div>
              <div className="w-[1px] bg-reliableBlack50 h-[36px]" />
              <div className="-ml-[6px] pt-[4px] flex justify-center items-center">
                <span className="text-xs lg:text-[14px] text-[#A3A3A3] ml-8">
                  Emergency Road Assistance
                </span>
                <span className="text-xs lg:text-[16px] text-[#A3A3A3] font-bold ml-[10px] pt-[1px]">
                  1500 898
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile search bar */}
      {showSearchAction && (
        <div className="absolute top-0 left-0 h-screen w-screen bg-black bg-opacity-25 z-40 lg:hidden">
          <div className="sticky top-[60px] left-0 flex items-center justify-between bg-white h-10 w-full z-40 lg:hidden">
            <Input
              type="text"
              inputBackground={'bg-white'}
              iconClassName={'border-none'}
              inputClassName={'flex-1 border-none !text-xs'}
              inputWrapperClassName={'border-none'}
              icon={<MdSearch color="#BDBCBC" size={20} />}
              iconPosition="left"
              onChange={handleChange}
              onKeyPress={handleSubmtittedValue}
              value={inputValues}
            />

            <button
              className={
                'bg-white text-xs uppercase font-normal text-reliableBlack h-auto py-2 px-3.5 border-l border-reliableBlack10'
              }
              onClick={() => handleCloseShowSearch()}
            >
              Cancel
            </button>
          </div>

          {showAutoCompleteBox && (
            <SearchBoxAutoComplete dataSearch={dataSearch} value={debouncedValue} />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default Navbar;
